//packages
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
//global components
import MainMenu from "../../_components/MainMenu";
import MainFooter from "../../_components/MainFooter";
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from "../../_services/menu.service";
import { postService } from "../../_services/post.service";
//styles
import "./News.sass";

class New extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {},
      },
      menu: {},
      topbarMenu: {},
      news: {
        items: []
      },
      branches: [],
      nextPage: {},
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user,
      });
    } else {
      this.setState({
        user: {
          details: {},
        },
      });
    }

    Promise.allSettled([
      postService.getByType("news", 1, 3).then((news) => {
          menuService
            .getMenuByName("default")
            .then((menu) => this.setState({ menu, news: { items: news}}));
        }),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      postService.getBranchesFooter('branch').then(branches => this.setState({ branches }))
    ]).then(() => this.setState({ loading: false }))
  }

  getTextValue = (html) => {
    if (html) {
      var span = document.createElement("span");
      span.innerHTML = html;
      // let getHtml = html.replace(/<p[^>]*>/g, "<p>");

      //if the value contains <p>
      const getPTag = span.getElementsByTagName("p")[0].innerText;
      //get all text content in elements
      const getText = span.textContent || span.innerText;

      return getPTag + "..." || getText.substr(0, 260) + "...";
    } else {
      return false;
    }
  };

 

  render() {
    const { loading, user, menu, topbarMenu, news, branches } = this.state;
    news.items.sort((a,b) => {
      return a.id - b.id
    })

    return (
      <>
        <PreLoader loading={loading} />
        <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
        <div className="jumbotron page-title py-5">
          <div className="container">
            <h1 className="text-white">Latest News</h1>
          </div>
        </div>
        {news &&
        <section className="main-content">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb bg-transparent m-0">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      News
                    </li>
                  </ol>
                </nav>
                <hr className="m-0 mb-4" />
              </div>
            </div>
            {news && news.items &&
            <>
              <div className="card-deck my-5">
                {news.items.map((news, index) =>(
                  <React.Fragment key={index}>
                    <div className="card">
                      <img className="card-img-top" src={news.acf.image ? news.acf.image : ""} alt="..."/>
                      <div className="card-body">
                        <h5 className="card-title">{news.title.rendered}</h5>
                        <p className="card-text headings-remove p-tags" >
                          {news.acf.header? news.acf.header :""}
                        </p>
                      </div>
                      <div className="card-footer text-left">
                        <a className="btn btn-primary btn-sm"
                          href={"/news/" + news.slug}
                          role="button"
                        >
                            Read Full Article {" "}
                            <FontAwesomeIcon icon={faLongArrowAltRight} />
                        </a>
                      </div>
                    </div>

                  </React.Fragment>
                ))}
               
              </div>	
            		
            {news && news.total > news.items.length &&
              <div id="loadingPage" style={{display: 'block'}}></div>
            }
            </> 
            }
          </div>
        </section>
       
        }
        <MainFooter menu={menu} branches={branches} />
      </>
    );
  }
}

export { New };
